import axios, { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Dropdown } from "semantic-ui-react";
import { AdminContext } from "../../contexts/AdminContext";
import { config } from "../../contexts/UrlContext";
import AuthContext from "../../contexts/AuthContext";
import { getRequest, postRequest } from "../../services/axiosService";
import { AuthType } from "../Interfaces/AdminInterface";
import { decrypt } from "../../services/Encryption";

const AuthTypeOptions = [
    { key: 'none', value: AuthType.None, text: 'None' },
    { key: 'username-password', value: AuthType.UsernamePassword, text: 'Username/Password' }
]

function Email() {

    const [sendFrom, setSendFrom] = useState<string>("");
    const [mailHost, setMailHost] = useState<string>("");
    const [mailPort, setMailPort] = useState<string>("");
    const [licenseExpiryContacts, setLicenseExpiryContacts] = useState<string>("");
    const [errorContacts, setErrorContacts] = useState<string>("");
    const [statisticsContacts, setStatisticsContacts] = useState<string>("");
    const [authType, setAuthType] = useState<AuthType>(AuthType.None);
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const { emailSettings, setEmailSettings } = useContext(AdminContext);
    const { auth } = useContext(AuthContext);

    useEffect(() => {
        getEmailSettings();
    }, []);

    const getEmailSettings = () => {
        setSendFrom(emailSettings.sendFrom);
        setMailHost(emailSettings.mailHost);
        setMailPort(emailSettings.mailPort);
        setLicenseExpiryContacts(emailSettings.licenseExpiryContacts);
        setErrorContacts(emailSettings.errorContacts);
        setStatisticsContacts(emailSettings.statisticsContacts);
        setAuthType(emailSettings.authType);
        setUsername(decrypt(emailSettings.username));
        setPassword(decrypt(emailSettings.password));
    }

    const saveSettings = async () => {
        try {
            let newSettings = {
                sendFrom: sendFrom,
                mailHost: mailHost,
                mailPort: mailPort,
                licenseExpiryContacts: licenseExpiryContacts,
                errorContacts: errorContacts,
                statisticsContacts: statisticsContacts,
                authType: authType,
                username: username,
                password: password,
            }
            let response: AxiosResponse = await postRequest(auth, `/Admin/SaveEmailSettings`, newSettings);
            toast.success(`Settings saved`);
            setEmailSettings(newSettings)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to save Settings`);
        }
    }

    const sendStatsEmail = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/SendStatisticsEmail`);
            toast.success("Stats email has been sent");
        } catch (error) {
            console.log(error);
            toast.error(`Unable to send statistics email`);
        }
    }

    const handleBlur = (e: any) => {
        if (e.currentTarget.value === '0') e.currentTarget.value = '1'
    }

    const  handleKeypress = (e: any) => {
        const characterCode = e.key
        if (characterCode === 'Backspace') return

        const characterNumber = Number(characterCode)
        if (characterNumber >= 0 && characterNumber <= 9) {
            if (e.currentTarget.value && e.currentTarget.value.length) {
                return
            } else if (characterNumber === 0) {
                e.preventDefault()
            }
        } else {
            e.preventDefault()
        }
    }

    return (
        <div id="email-settings" className="ui admin-container">
            <div className="header blue headerStyleBlue" style={{ marginLeft: 0 }} >SMTP Authentication</div>
            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>AUTHENTICATION TYPE</div>
            <Dropdown id="auth-type" placeholder='Select Authentication Type' style={{ backgroundColor: "#e5e5e5" }} fluid
                selection options={AuthTypeOptions} value={authType} onChange={(e, { value }) => { setAuthType(value as AuthType) }} />

            {authType === AuthType.UsernamePassword &&
                <div>
                    <div className="header gray headerStyleGray" style={{ marginLeft: 0 }} >USERNAME</div>
                    <div className="ui input fluid" >
                        <input type="text" style={{ backgroundColor: "#e5e5e5" }}
                            placeholder="Enter Username" id="username" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </div>
                    <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>PASSWORD</div>
                    <div className="ui input fluid" >
                        <input type="password" style={{ backgroundColor: "#e5e5e5" }}
                            placeholder="Enter Password" id="password" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                    </div>
                </div>
            }
            <div className="header blue headerStyleBlue" style={{ marginLeft: 0 }}>Mail Settings</div>

            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }} >MAIL HOST</div>
            <div className="ui input fluid" >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Mail Host" id="mailhost" value={mailHost} onChange={(e) => {setMailHost(e.target.value)}} />
            </div>

            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>MAIL PORT</div>
            <div className="ui input fluid" >
                <input id="mail-port" type="number" style={{ backgroundColor: "#e5e5e5" }} value={mailPort} onKeyDown={handleKeypress} onBlur={handleBlur} onChange={(e) => {setMailPort(e.target.value)}} placeholder="Enter Mail Port" />
            </div>

            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>SEND FROM</div>
            <div className="ui input fluid" >
                <input id="send-from" type="text" style={{ backgroundColor: "#e5e5e5" }} value={sendFrom} onChange={(e) => {setSendFrom(e.target.value)}} placeholder="Enter Send From" />
            </div>

            <div className="header blue headerStyleBlue" style={{ marginLeft: 0 }} >Contacts</div>

            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>LICENSE EXPIRY CONTACTS</div>
            <div className="ui input fluid" >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter License Expiry Contacts" id="lic-contacts" value={licenseExpiryContacts} onChange={(e) => {setLicenseExpiryContacts(e.target.value)}} />
            </div>
            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>ERROR NOTIFICATION CONTACTS</div>
            <div className="ui input fluid" >
                <input type="text" id="error-contacts" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Error Notification Contacts" value={errorContacts} onChange={(e) => {setErrorContacts(e.target.value)}} />
            </div>

            <div className="header gray headerStyleGray" style={{ marginLeft: 0 }}>STATISTICS CONTACTS</div>
            <div className="ui input fluid"  >
                <input type="text" id="error-contacts" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter  Contacts" value={statisticsContacts} onChange={(e) => {setStatisticsContacts(e.target.value)}} />
            </div>
            
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                <Button id="email-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                <Button id="email-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={getEmailSettings}>Cancel</Button>
                <Button onClick={sendStatsEmail}  style={{  marginLeft: 5 }}>Send Stats Email</Button>
            </div>
        </div>
    )
}

export default Email;